/**
 * T088: Prompt Filters Component
 * Combined filter controls for prompts list
 */

import { SearchInput } from './search-input'
import { CategoryFilter } from './category-filter'
import { TagFilter } from './tag-filter'

export interface PromptFiltersState {
  q?: string
  categoryId?: string
  tagIds: string[]
}

interface PromptFiltersProps {
  filters: PromptFiltersState
  onChange: (filters: PromptFiltersState) => void
}

export function PromptFilters({ filters, onChange }: PromptFiltersProps) {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex-1">
          <SearchInput
            value={filters.q ?? ''}
            onChange={(q) => onChange({ ...filters, q: q || undefined })}
            placeholder="Search prompts..."
          />
        </div>
        <CategoryFilter
          value={filters.categoryId}
          onChange={(categoryId) => onChange({ ...filters, categoryId })}
        />
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">Tags:</span>
        <TagFilter
          value={filters.tagIds}
          onChange={(tagIds) => onChange({ ...filters, tagIds })}
        />
      </div>
    </div>
  )
}
